import React, { useContext, useEffect, useState } from 'react'
import styles from './PrivacyModal.module.css'
import axios from 'axios'
import ParagraphsWithVariables from '../Paragraphs/ParagraphWithVariables'
import { useAuth0 } from '@auth0/auth0-react'
import PrivacyModalContext from '../../../context/PrivacyModalContext'

import Backdrop from '../../../components/UI/Backdrop/Backdrop'
import Spinner from '../../../components/UI/Spinner/SpinnerPlenna'
import Checkbox from '../../../components/UI/Inputs/Checkbox.jsx'
import HeaderContext from '../../../context/HeaderContext.js'
import { buildPatientsApiUrl } from '../../../utils/patientsApiBaseUrl'

export const PrivacyModal = () => {
  const { openModal, setOpenModal } = useContext(PrivacyModalContext)
  const { setUserInfo } = useContext(HeaderContext)
  const { getIdTokenClaims } = useAuth0()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    const fetchPrivacy = async () => {
      if (!openModal) return

      setLoading(true)
      setError(null)
      setChecked(false)

      try {
        const idToken = await getIdTokenClaims()
        const getPrivacyPath = buildPatientsApiUrl('/v1/privacy-notice')
        if (!getPrivacyPath || !idToken?.__raw) {
          throw new Error('Missing privacy notice URL or auth token')
        }

        const response = await axios.get(getPrivacyPath, {
          headers: {
            Authorization: `Bearer ${idToken.__raw}`
          }
        })
        setData(response.data.data)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }
    fetchPrivacy()
  }, [openModal, getIdTokenClaims])

  const acceptPrivacyNotice = async () => {
    const idToken = await getIdTokenClaims()
    setLoading(true)
    try {
      const putPrivacyPath = buildPatientsApiUrl('/v1/accept-privacy-notice')
      if (!putPrivacyPath || !idToken?.__raw) {
        throw new Error('Missing accept-privacy URL or auth token')
      }

      const response = await axios.put(
        putPrivacyPath,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      )
      if (response.data.message === 'success') {
        setUserInfo((prev) => ({
          ...prev,
          show_privacy: false
        }))
        setOpenModal(false)
      }
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  if (!openModal) return null
  return (
    <div className={styles.overlay}>
      <Backdrop show={loading}>
        <Spinner />
      </Backdrop>
      <div className={styles.modal}>
        <h2 className={styles.title}>
          Aviso de Privacidad, <br /> T&C
        </h2>
        {error && <p>Error al cargar el aviso</p>}

        {!loading && data && (
          <div className={styles.content}>

            <ParagraphsWithVariables
              data={{
                paragraph: data?.Terms?.paragraphs[0],
                variables: data?.Terms?.variables
              }}
            />

          </div>
        )}

        {!loading && data && (
          <Checkbox
            active={checked}
            onClick={() => setChecked((prev) => !prev)}
            containerClassName={styles.checkboxContainer}
          >
            {/* Texto */}
            <span className={styles.textPrivacy}>
              Acepto el{' '}
              <span
                className={styles.link}
                onClick={(e) => {
                  e.stopPropagation()
                  window.open('https://www.soyplenna.com/footer/aviso-de-privacidad', '_blank')
                }}
              >
                Aviso de Privacidad,
              </span>{' '}
              <span
                className={styles.link}
                onClick={(e) => {
                  e.stopPropagation()
                  window.open('https://www.soyplenna.com/footer/terminos-y-condiciones', '_blank')
                }}
              >
                T&C
              </span>{' '}
              y autorizo el{' '}
              <span
                className={styles.link}
                onClick={(e) => {
                  e.stopPropagation()
                  window.open('https://www.soyplenna.com/documentos/check-up-plus-consentimiento-informado', '_blank')
                }}
              >
                tratamiento de mis datos personales
              </span>{' '}
              conforme a dicho aviso.
            </span>
          </Checkbox>
        )

        }

        <button
          className={`${styles.button} ${!checked ? styles.buttonDisabled : ''
            }`}
          disabled={!checked}
          onClick={() => { acceptPrivacyNotice() }}
        >
          Continuar
        </button>
      </div>
    </div>
  )
}
